import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';
import { useContext, useEffect, useState } from 'react';
import { getAllAuth0Users } from '../../../api/auth0Api';
import { GestionUsuariosContext } from '../../../context/GestionUsuariosContext';

const LIMIT = 12;

export function useGetAllUsuariosPaginated() {
  const [page, setPage] = useState(1);
  const { inputValueSearch, statusFilter, centersFilter } = useContext(GestionUsuariosContext);

  useEffect(() => {
    setPage(1);
  }, [statusFilter, centersFilter, inputValueSearch]);

  const { getAccessTokenSilently } = useAuth0();
  const { data: usersPaginated, isLoading } = useQuery(
    ['all-users', page, LIMIT, statusFilter, inputValueSearch, centersFilter],
    async () => {
      const token = await getAccessTokenSilently();
      return await getAllAuth0Users(token, {
        page: page - 1,
        per_page: LIMIT,
        ...(statusFilter !== 'all' && { blocked: statusFilter }),
        ...(inputValueSearch && { search: inputValueSearch }),
        ...(centersFilter && { centers: centersFilter }),
      });
    },
  );

  return {
    usersPaginated,
    isLoading,
    limit: LIMIT,
    setPage,
    page,
  };
}
